import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

const initialTasks = [
  {
    id: 1,
    title: "Task 1",
  },
  {
    id: 2,
    title: "Task 2",
  },
  {
    id: 3,
    title: "Task 3",
  },
];

function App() {
  const [tasks, setTasks] = useState(initialTasks);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(tasks);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setTasks(items);
  };

  const [collapsed, setCollapsed] = React.useState(false);
  return (
      <div style={{ direction: "ltr", display: 'flex', height: '100%', minHeight: '400px' }}>
        <Sidebar collapsed={collapsed}>
          <Menu>
            <MenuItem> Documentation</MenuItem>
            <MenuItem> Calendar</MenuItem>
            <MenuItem> E-commerce</MenuItem>
            <MenuItem> Examples</MenuItem>
          </Menu>
        </Sidebar>
        <main style={{ padding: 10 }}>
          <div>
            <button className="sb-button" onClick={() => setCollapsed(!collapsed)}>
              Collapse
            </button>
          </div>
        </main>
      </div>
  );
}

export default App;
